export default __webpack_public_path__ + "static/media/tmp_fincar_image03.e3f169df.png";